import { Container } from 'unstated';
import { auth0client } from '../auth/Auth';
import history from '../auth/History';
import { Provider } from '../types/provider';
import {
  Step1,
  Step2,
  Step3,
  Step4,
  Step6,
  Step7,
  Step8,
  Step10,
} from '../types/steps';
import axios from 'axios';
import { BASE_SERVER_URL } from '../Constants';
import { createProviderId } from '../utils/utils';
import { resizeImage } from '../utils/imageResize';
import FormData from 'form-data';
import { brands } from './MakeupBrandsStaticData';
import { codeImages } from './verificationCodeImages';
interface AppContainerState {
  provider: Provider;
  step1: Step1;
  step2: Step2;
  step3: Step3;
  step4: Step4;
  step6: Step6;
  step7: Step7;
  step8: Step8;
  step10: Step10;
  loggedIn: boolean;
  loadedProvider: boolean;
  currStep: number;
  latLng: {
    lat: string;
    lng: string;
  };
  hearUs: '';
  loading: boolean;
  emailIsValid: boolean;
  servicesOffered: string[];
  mobileSelection: string;
  homeSelection: string;
}

export class ContainerNew extends Container<AppContainerState> {
  public stepsMapping: string[] = [
    undefined, // because nothing exist at step 0
    'nameEmail',
    'profilePic',
    'selfieVerification',
    'services',
    'serivceTypes',
    'homeStudioLocation',
    'mobileLocation',
    'makeup',
    'instagram',
    'hearUs',
    'agreement',
    'finish',
  ];

  constructor() {
    super();

    this.state = {
      provider: {
        mobile: '',
        lastCompletedStep: -1,
        name: '',
        country: '',
        offersHome: false,
        offersMobile: false,
        isActiveExists: false,
        isActive: false
      },
      step1: {
        first_name: '',
        last_name: '',
        email: '',
        provider_id: '',
      },
      step2: {
        profile_image: '',
      },
      step3: {
        can_do_hair_down: false,
        can_do_hair_up: false,
        can_do_makeup: false,
      },
      step4: {
        instagram: {
          username: '',
          found: false,
          verified: false,
        },
      },
      step6: {
        street_address: '',
        postcode: '',
        state: '',
        suburb: '',
      },
      step7: {
        home_studio_address: {
          full_address: '',
          country: '',
          suburb: '',
          postcode: '',
          state: '',
          street_address: '',
          apartment: '',
        },
        home_pricing: {
          can_do_makeup: false,
          can_do_hair_down: false,
          can_do_hair_up: false,
        },
        location: {
          type: 'Point',
          coordinates: [],
        },
        home_studio_status: 0,
      },
      step8: {
        max_distance: 30,
        free_distance: 3,
        max_distance_job_cost: undefined,
      },
      step10: {
        makeup_brands: [],
        selectedBrands: [],
        availableBrands: brands.map(name => ({ name })),
      },
      loadedProvider: false,
      loggedIn: auth0client.isAuthenticated(),
      currStep: -1,
      latLng: {
        lat: '',
        lng: '',
      },
      hearUs: '',
      loading: false,
      emailIsValid: false,
      servicesOffered: [],
      mobileSelection: '',
      homeSelection: '',
    };
    if (auth0client.isAuthenticated()) {
      this.fetchProvider();
    }
  }
  step2imageUpload = async (file: File, onboardingStep: number) => {
    //resize image
    const resizedImage = await resizeImage({ maxSize: 3000, file: file });
    let formData = new FormData();
    const config = {
      headers: {
        accept: 'application/json',
        'Accept-Language': 'en-US,en;q=0.8',
        'Content-Type': `multipart/form-data; boundary=${formData._boundary}`,
        Authorization: this.getUserAccessKey(),
      },
    };
    formData.append('profilePic', resizedImage);
    formData.append('mobile', this.getUserMobile());
    formData.append('onboarding_step', onboardingStep);
    let response = await axios.post(
      BASE_SERVER_URL + '/profile-image-upload',
      formData,
      config
    );
    let step2 = this.state.step2;
    await this.setState({
      step2: {
        profile_image: response.data,
      },
    });
  };

  step11imageUpload = async (file: File, code: string) => {
    const resizedImage = await resizeImage({ maxSize: 1000, file: file });
    let formData = new FormData();
    const config = {
      headers: {
        accept: 'application/json',
        'Accept-Language': 'en-US,en;q=0.8',
        'Content-Type': `multipart/form-data; boundary=${formData._boundary}`,
        Authorization: this.getUserAccessKey(),
      },
    };
    formData.append('mobile', this.getUserMobile());
    formData.append('onboarding_step', this.state.currStep);
    formData.append('verification_image', resizedImage);
    formData.append('code', code);
    let response = await axios.post(
      BASE_SERVER_URL + '/upload-verification-photo',
      formData,
      config
    );
  };

  //step functions
  onStep1FieldChange = (event: any) => {
    let step1 = this.state.step1;
    step1[event.target.name] = event.target.value;
    this.setState({
      step1: step1,
    });
    if (event.target.name === 'email') {
      this.validateEmail(event.target.value);
    }
  };

  validateEmail = email => {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    let valid = re.test(String(email).toLowerCase());
    this.setState({
      emailIsValid: valid,
    });
  };

  updateNameEmail = async (
    step1Fields: Step1,
    onboardingStep: Number,
    queryString: string
  ) => {
    const queryObj = this.parseQuery(queryString);
    const providerId = createProviderId(
      step1Fields.first_name.trim(),
      step1Fields.last_name.trim()
    );
    let updateFields = {
      first_name: step1Fields.first_name.replace(/[^a-zA-Z ]/g, ''),
      last_name: step1Fields.last_name.replace(/[^a-zA-Z ]/g, ''),
      email: step1Fields.email,
      provider_id: providerId,
      mobile: this.getUserMobile(),
      onboarding_step: onboardingStep,
      short_id: queryObj.offer,
      lead_source: queryObj.ref,
      signup_as: queryObj.signup
    };
    let step1 = { ...this.state.step1 };
    step1.provider_id = providerId;
    this.setState({
      step1: step1,
    });
    let provider = await this.updateProvider(updateFields);
  };

  generateCodeImages = (): { images: string[]; code: string } => {
    let numbers = '';
    let images = [];
    for (let i = 0; i < 3; i++) {
      let num = Math.floor(Math.random() * 5) + 1;
      numbers = numbers + num.toString();
      images.push(codeImages[num]);
    }
    return { images: images, code: numbers };
  };

  parseQuery = (queryString: string): any => {
    var query = {};
    var pairs = (queryString[0] === '?'
      ? queryString.substr(1)
      : queryString
    ).split('&');
    for (var i = 0; i < pairs.length; i++) {
      var pair = pairs[i].split('=');
      query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
    }
    return query;
  };

  setInstagramUsername = (username: string) => {
    let step4 = this.state.step4;
    step4.instagram.username = username;
    this.setState({
      step4: step4,
    });
  };

  setInstagramFound = (found: boolean) => {
    let step4 = this.state.step4;
    step4.instagram.found = found;
    this.setState({
      step4: step4,
    });
  };

  handleTagSelect = tag => {
    let step10 = this.state.step10;
    if (!step10.selectedBrands.find(brand => brand.name === tag.name)) {
      step10.selectedBrands = [...step10.selectedBrands, tag];
      step10.availableBrands = [
        ...step10.availableBrands.filter(brand => brand !== tag),
      ];
      this.setState({ step10: step10 });
    }
  };

  joinMakeupBrands = async () => {
    let step10 = this.state.step10;
    let makeup_brands = '';

    for (let b of step10.selectedBrands) {
      makeup_brands += b.name + ' ,';
    }
    step10.makeup_brands = [makeup_brands];
    await this.setState({
      step10: step10,
    });
    return;
  };

  handleTagRemove = index => {
    let step10 = this.state.step10;
    const item = step10.selectedBrands[index];
    step10.selectedBrands = [
      ...step10.selectedBrands.filter(brand => brand !== item),
    ];
    this.setState({
      step10: step10,
    });
  };

  setStep7Values = async (values: any) => {
    let step7 = this.state.step7;
    step7.home_studio_address.country = values.country;
    step7.home_studio_address.suburb = values.suburb;
    step7.home_studio_address.full_address = values.formattedAddress;
    step7.home_studio_address.state = values.state;
    step7.home_studio_address.postcode = values.postcode;
    step7.home_studio_address.street_address = values.street;
    step7.location = {
      type: 'Point',
      coordinates: [values.lng, values.lat],
    };
    step7.home_pricing = {
      can_do_hair_down: this.state.step3.can_do_hair_down,
      can_do_hair_up: this.state.step3.can_do_hair_up,
      can_do_makeup: this.state.step3.can_do_makeup,
    };
    step7.home_studio_status = 10;
    await this.setState({
      step7: step7,
    });
  };

  onStep7fieldChange = async e => {
    let step7 = this.state.step7;
    step7.home_studio_address[e.target.name] = e.target.value;
    await this.setState({
      step7: step7,
    });
  };

  hasMobileServiceSet = () => {
    return !!this.state.step6.postcode;
    if (
      this.state.step6.postcode &&
      this.state.mobileSelection === 'yes' &&
      this.state.step8.max_distance &&
      this.state.step8.max_distance_job_cost &&
      this.state.step8.free_distance
    ) {
      return true;
    }
    return false;
  };

  onHomeAddressChange = e => {
    let step7 = this.state.step7;
    step7.home_studio_address.full_address = e.target.value;
    this.setState({
      step7: step7,
    });
  };

  updateProviderTravel = async () => {
    let config = {
      headers: { Authorization: this.getUserAccessKey() },
    };
    let data = {
      mobile: this.getUserMobile(),
      radius: this.state.step8.max_distance,
      postcode: this.state.step6.postcode,
    };
    await axios.post(
      BASE_SERVER_URL + '/update-provider-postcodes',
      data,
      config
    );
    return;
  };

  handleStep8inputChange = e => {
    let step8 = this.state.step8;
    step8[e.target.name] = parseInt(e.target.value);
    this.setState({
      step8: step8,
    });
  };

  /*   submitAndAdvanceStep = async (step: number) => {
      await this.setStep(step);
      this.submitThisStep(step - 1);
    } */

  setMobileSelection = async (s: string) => {
    await this.setState({
      mobileSelection: s,
    });
    return;
  };

  setHomeSelection = async (s: string) => {
    await this.setState({
      homeSelection: s,
    });
    return;
  };

  step3update = async (onboardingStep: Number) => {
    let servicesOffered = [];
    let step3 = this.state.step3;
    for (const key of Object.keys(step3)) {
      console.log(key);
      if (
        step3[key] === true &&
        key !== 'can_do_makeup' &&
        key !== 'can_do_hair_down' &&
        key !== 'can_do_hair_up'
      ) {
        servicesOffered.push(key);
      }
    }
    await this.setState({
      servicesOffered: servicesOffered,
    });
    await this.updateProvider({
      can_do_hair_down: this.state.step3.can_do_hair_down,
      can_do_hair_up: this.state.step3.can_do_hair_up,
      can_do_makeup: this.state.step3.can_do_makeup,
      mobile: this.getUserMobile(),
      onboarding_step: onboardingStep,
      services_offered: this.state.servicesOffered,
    });
    return;
  };

  step6update = async (onboardingStep: Number) => {
    await this.updateProvider({
      mobile: this.getUserMobile(),
      onboarding_step: onboardingStep,
      hair_cutting: {
        brands: this.state.step10.makeup_brands,
        home_studio_status: 10,
        offers_home: this.state.provider.offersHome ? true : false,
        offers_mobile: this.state.provider.offersHome ? true : false
      },
      home_studio_address: this.state.step7.home_studio_address,
      location: this.state.step7.location
    });
    return;
  };

  updateInstagram = (onboardingStep: Number) => {
    this.updateProvider({
      mobile: this.getUserMobile(),
      onboarding_step: onboardingStep,
      hair_cutting: {
        brands: this.state.step10.makeup_brands,
        home_studio_status: 10,
        offers_home: this.state.provider.offersHome ? true : false,
        offers_mobile: this.state.provider.offersMobile ? true : false
      },
      instagram: this.state.step4.instagram
    });
  };

  updateProfileImage = (onboardingStep: Number) => {
    this.updateProvider({
      onboarding_step: onboardingStep,
      mobile: this.getUserMobile(),
    });
  };

  step7update = async (onboardingStep: Number) => {
    let offers_mobile = this.state.mobileSelection === 'yes' ? true : false;
    this.updateProviderTravel();
    await this.updateProvider({
      mobile: this.getUserMobile(),
      onboarding_step: onboardingStep,
      max_distance: this.state.step8.max_distance,
      free_distance: this.state.step8.free_distance,
      max_distance_job_cost: this.state.step8.max_distance_job_cost,
      street_address: this.state.step6.street_address,
      suburb: this.state.step6.suburb,
      state: this.state.step6.state,
      postcode: this.state.step6.postcode,
      offers_mobile: offers_mobile,
    });
    return;
  };

  /*  submitThisStep = async (step: number) => {
     console.log(step);
     switch (step) {
       case 1: //email name
         await this.step1Update(this.state.step1);
         break;
       case 2: // profile image
         await this.updateProvider({ onboarding_step: this.state.currStep - 1, mobile: this.getUserMobile() });
         break;
       //step 2 only has step updater in db , image upload, is other function.
       case 3: //services
         await this.step3update();
         break
       case 4: //instagram
         await this.updateProvider({ mobile: this.getUserMobile(), onboarding_step: this.state.currStep - 1, instagram: this.state.step4.instagram })
         break
       case 6: //home studio
         await this.step6update();
         break
       case 7: //mobile services
         await this.step7update();
         break;
       case 9: //makeup brands
         await this.joinMakeupBrands();
         await this.updateProvider({
           mobile: this.getUserMobile(), onboarding_step: this.state.currStep - 1, makeup_brands: this.state.step10.makeup_brands
         })
         break
       case 10: //verification step
         await this.updateProvider({
           mobile: this.getUserMobile(), onboarding_step: this.state.currStep - 1, found_reason: this.state.hearUs
         })
         break
     } 
   }
  */

  updateVerificationStep = async (onboardingStep: Number) => {
    await this.updateProvider({
      mobile: this.getUserMobile(),
      onboarding_step: onboardingStep,
    });
  };

  updateMakeupBrands = async (onboardingStep: Number) => {
    await this.joinMakeupBrands();
    await this.updateProvider({
      mobile: this.getUserMobile(),
      onboarding_step: onboardingStep,
      hair_cutting: { brands: this.state.step10.makeup_brands },
    });
  };

  handleStep3Switch = (key: string) => {
    let step3 = this.state.step3;
    step3[key] = !step3[key];
    this.setState({
      step3: step3,
    });
  };
  setProviderLatLng = async (address: string) => {
    let config = {
      headers: { Authorization: this.getUserAccessKey() },
    };
    let response = await axios.get(
      BASE_SERVER_URL + '/get-lat-lng?address=' + address,
      config
    );
    let latLng = response.data;
    this.setState({
      latLng: latLng,
    });

    this.updateProvider({
      mobile: this.getUserMobile(),
      mobile_location: { type: 'Point', coordinates: [latLng.lng, latLng.lat] },
    });
  };

  onHearUsChange = e => {
    this.setState({
      hearUs: e.target.value,
    });
  };

  updateProvider = async (fieldsToUpdate: Object) => {
    await this.setState({
      loading: true,
    });
    let data = fieldsToUpdate;
    let config = {
      headers: { Authorization: this.getUserAccessKey() },
    };
    let provider = await axios.post(
      BASE_SERVER_URL + '/update-stylist-2',
      data,
      config
    );
    this.setState({
      loading: false,
    });
    return provider.data;
  };

  setStep6State = async (state: any) => {
    await this.setState({
      step6: {
        street_address: state.street_address,
        postcode: state.postcode,
        state: state.state,
        suburb: state.suburb,
      },
      latLng: {
        lat: state.lat,
        lng: state.lng,
      },
    });
    return;
  };
  setStep6Address = (address: string) => {
    let step6 = this.state.step6;
    step6.street_address = address;
    this.setState({
      step6: step6,
    });
  };
  hasHomeStudioData = () => {
    if (
      this.state.step7.location.coordinates[0] &&
      this.state.step7.home_studio_address.street_address &&
      this.state.homeSelection === 'yes'
    )
      return true;
    return false;
  };
  setStep = async (step: number) => {
    await this.setState({
      currStep: step,
    });
    return this.state.currStep;
  };

  fetchProvider = async () => {
    let data = {
      mobile: this.getUserMobile(),
    };
    let config = {
      headers: {
        Authorization: this.getUserAccessKey(),
      },
    };
    let provider = await axios.post(
      BASE_SERVER_URL + '/create-stylist',
      data,
      config
    );
    console.log(provider.data);
    await this.setProviderData(provider.data);
    return;
  };

  isProviderLoaded = () => {
    return this.state.loadedProvider;
  };

  handleInstagramUsernameChange = e => {
    let step4 = this.state.step4;
    step4.instagram.username = e.target.value;
    this.setState({
      step4: step4,
    });
  };

  isProviderFirstTime = () => {
    if (this.state.provider.lastCompletedStep === 0) {
      return true;
    } else {
      return false;
    }
  };

  setHomeStudioStatus = (status: number) => {
    this.updateProvider({
      home_studio_status: 0,
      onboarding_step: this.state.currStep - 1,
      mobile: this.getUserMobile(),
    });
  };

  takeToLastCompletedStep = queryString => {
    let stepToPush = this.state.provider.lastCompletedStep + 1;
    history.push('/step-' + stepToPush + queryString);
    this.setState({
      currStep: stepToPush,
    });
  };

  setProfileImageUrl = (url: string) => {
    let step2 = this.state.step2;
    step2.profile_image = url;
    this.setState({
      step2: step2,
    });
  };

  takeToFirstStepIfNeeded = queryString => {
    if (this.isProviderLoaded && this.state.provider.lastCompletedStep === 0) {
      history.push('/step-1' + queryString);
    }
  };

  takeToLastStepIfNeeded = queryString => {
    console.log(this.state);
    if (
      this.isProviderLoaded &&
      (this.state.provider.lastCompletedStep === 10 ||
        this.state.provider.isActiveExists === true)
    ) {
      history.push('/step-9' + queryString);
    }
  };

  //sets the data for all the steps.
  async setProviderData(provider: any) {
    let latLng = provider.mobile_location
      ? {
        lat: provider.mobile_location.coordinates[1],
        lng: provider.mobile_location.coordinates[0],
      }
      : {
        lat: '',
        lng: '',
      };
    const lastCompletedStep = provider.onboarding_step;
    let newProvider = {
      mobile: this.getUserMobile(),
      lastCompletedStep: lastCompletedStep,
      isActiveExists:
        provider.isActive === true || provider.isActive === false
          ? true
          : false,
      name: provider.first_name,
      country: provider.country,
      offersHome: provider.hair_cutting && (provider.hair_cutting.offers_home === true) ? true : false,
      offersMobile: provider.hair_cutting && (provider.hair_cutting.offers_mobile === true) ? true : false,
      isActive: provider.isActive ? true : false
    };
    let step1 = {
      first_name: provider.first_name,
      last_name: provider.last_name,
      email: provider.email,
      provider_id: provider.provider_id,
    };
    this.validateEmail(provider.email);
    let step2 = {
      profile_image: provider.profile_image,
    };

    let step3 = {
      can_do_hair_down: provider.can_do_hair_down,
      can_do_hair_up: provider.can_do_hair_up,
      can_do_makeup: provider.can_do_makeup,
    };
    let servicesOffered = provider.services_offered
      ? provider.services_offered
      : [];
    for (let s of servicesOffered) {
      step3[s] = true;
    }
    let step4 = {
      instagram: provider.hair_cutting && provider.hair_cutting.instagram
        ? provider.hair_cutting.instagram
        : {
          username: '',
          found: false,
          verified: false,
        },
    };
    let step6 = {
      suburb: provider.suburb,
      postcode: provider.postcode,
      state: provider.state,
      street_address: provider.street_address,
    };
    let step7 = {
      home_studio_address: {
        full_address: provider.home_studio_address
          ? provider.home_studio_address.full_address
          : '',
        country: provider.home_studio_address
          ? provider.home_studio_address.country
          : '',
        suburb: provider.home_studio_address
          ? provider.home_studio_address.suburb
          : '',
        postcode: provider.home_studio_address
          ? provider.home_studio_address.postcode
          : '',
        state: provider.home_studio_address
          ? provider.home_studio_address.state
          : '',
        street_address: provider.home_studio_address
          ? provider.home_studio_address.street_address
          : '',
        apartment: provider.home_studio_address
          ? provider.home_studio_address.apartment
          : '',
      },
      home_pricing: {
        can_do_makeup: provider.home_pricing
          ? provider.home_pricing.can_do_makeup
          : false,
        can_do_hair_down: provider.home_pricing
          ? provider.home_pricing.can_do_hair_down
          : false,
        can_do_hair_up: provider.home_pricing
          ? provider.home_pricing.can_do_hair_up
          : false,
      },
      location: provider.location
        ? provider.location
        : {
          type: 'Point',
          coordinates: [],
        },
      home_studio_status: provider.home_studio_status
        ? provider.home_studio_status
        : 0,
    };

    let step8 = {
      max_distance: provider.max_distance ? provider.max_distance : 30,
      free_distance: provider.free_distance ? provider.free_distance : 3,
      max_distance_job_cost: provider.max_distance_job_cost,
    };
    let step10;
    if (provider.hair_cutting && provider.hair_cutting.brands.length) {
      step10 = this.parseMakeupBrands(provider.hair_cutting.brands);
    } else {
      step10 = {
        makeup_brands: [],
        selectedBrands: [],
        availableBrands: [], //brands.map((name, id) => ({ name, id }))
      };
    }

    let mobileSelection;
    if (provider.hair_cutting && (provider.hair_cutting.offers_mobile === true)) {
      mobileSelection = 'yes';
    } else if (provider.hair_cutting && (provider.hair_cutting.offers_mobile === false)) {
      mobileSelection = 'no';
    } else {
      mobileSelection = '';
    }

    let homeSelection;
    if (provider.hair_cutting && provider.hair_cutting.offers_home === true) {
      homeSelection = 'yes';
    } else if (provider.hair_cutting && provider.hair_cutting.offers_home === false) {
      homeSelection = 'no';
    } else {
      homeSelection = '';
    }

    await this.setState({
      provider: newProvider,
      step1: step1,
      step2: step2,
      step3: step3,
      step4: step4,
      step6: step6,
      step7: step7,
      step8: step8,
      step10: step10,
      loadedProvider: true,
      latLng: latLng,
      mobileSelection: mobileSelection,
      homeSelection: homeSelection,
    });
  }

  parseMakeupBrands = (brands: any) => {

    if (typeof brands === 'string') {
      brands = brands.trim();
      brands = brands.split(',');
    }
    console.log(brands);

    let selectedBrands = [];
    for (let i = 0; i < brands.length - 1; i++) {
      console.log(brands[i]);
      selectedBrands.push({
        id: i,
        name: brands[i],
      });
    }


    let step10 = this.state.step10;
    step10.selectedBrands = selectedBrands;
    return step10;
  };

  getProvider() {
    return this.state.provider;
  }
  //Auth Functions.
  isLoggedIn(): boolean {
    return this.state.loggedIn;
  }
  logout(): void {
    auth0client.logout();
  }
  getUserMobileWithoutCountry() {
    let profile = JSON.parse(auth0client.getProfile());
    return 0 + profile.name.substring(3);
  }
  getUserAccessKey() {
    return 'Bearer ' + auth0client.getIdToken();
  }
  getUserMobile() {
    let profile = JSON.parse(auth0client.getProfile());
    return profile.name;
  }

  handleProviderServiceType = type => {
    console.log(type);
    const provider = {
      ...this.state.provider,
      [type]: !this.state.provider[type],
    };
    this.setState({ provider });
  };
}
const AppContainer = new ContainerNew();
export default AppContainer;
